<template>
  <div
    :class="['flex flex-row gap10 site-page-card silo-card mb-8 p-5', !isCardInEditMode?'cursor-pointer':'']"
    @click="!isCardInEditMode ? onSiloClick() : undefined"
    @mousedown.middle.prevent="!isCardInEditMode ? onSiloClick('middle') : undefined"
  >
    <div v-if="['in_cart'].includes(silo?.content_report_order?.order_status)">
      <v-checkbox 
        hide-details="auto" 
        dense
        class="silo-checkbox"
        style="margin-top: 2px !important;"
        color="#007aff"
        :value="isSelected" 
        @click.stop="$emit('toggleSelected')"
      >
      </v-checkbox>
    </div>

    <div class="flex flex-column">
      <div class="silo-card-head">
        <div
          class="silo-card-title"
        >
          <div class="project-name">
            Order #{{ silo.content_report_order.id }}
            <!--
              <span
                v-if="!isCardInEditMode"
                style="cursor:text;"
                @click.stop="editedName = silo.name; isCardInEditMode = true;"
              >
                {{ silo.name }}
              </span>
              <v-text-field
                v-else
                autofocus
                outlined
                v-model="editedName"
                @blur="saveEditName()"
                @keypress.enter="saveEditName()"
                dense
                hide-details
                style="max-width: max-content; background-color: white"
              >
              </v-text-field>
            -->
          </div>

          <div
            v-if="!['paid', 'to_be_paid_by_invoice'].includes(silo?.content_report_order?.order_status)"
            class="align-center gap5"
            style="display: flex; padding: 2px 6px; border-radius: 4px; border: 1px dotted #D8E0ED; background:#F1F6FF;"
          >
            <img src="/static/blue_time_icon.svg" style="width: 15px; height: 15px;"> <span style="color: #014751;">Not ordered yet</span>
          </div>
        </div>
  
        <div
          class="is-size-6 title-font mainColor--text"
          style="margin-top: -3px;"
        >
          <v-btn icon :id="`dot-menu-for-${silo.id}`">
            <span
              class="material-icons-outlined mainColor--text"
              style="font-size: 30px"
              >more_horiz</span
            >
          </v-btn>
          <v-menu :activator="`#dot-menu-for-${silo.id}`" bottom offset-y>
            <v-list>
              <v-list-item v-if="isMissionControlSession" @click="onSiloClick('middle')">
                <v-list-item-title class="mainColor--text">
                  Open in new tab
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDeleteConfirmModal = true">
                <v-list-item-title class="mainColor--text">
                  Delete
                </v-list-item-title>
              </v-list-item>
              <template v-if="isWhiteGloveUser && isMissionControlSession">
                <v-list-item
                  v-if="silo.content_report_order.fulfillement_status !== 'pending'"
                  @click="updateOrder({set_pending: true})"
                >
                  <v-list-item-title class="mainColor--text">
                    Mark as {{ getFulfillementStatusLabel('pending')}}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="silo.content_report_order.fulfillement_status !== 'in_progress'"
                  @click="updateOrder({set_in_progress: true})"
                >
                  <v-list-item-title class="mainColor--text">
                    Mark as {{ getFulfillementStatusLabel('in_progress')}}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="silo.content_report_order.fulfillement_status !== 'completed'"
                  @click="updateOrder({set_completed: true})"
                >
                  <v-list-item-title class="mainColor--text">
                    Mark as {{ getFulfillementStatusLabel('completed')}}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
      <div class="mt-1 mainColor--text font-weight-regular">
        {{ toLocalDateString(silo.createdAt) }} <span style="color: var(--v-gray12Color-base);">•</span> {{ countValue }} {{ countValue > 1 ? 'keywords' : 'keyword' }}
      </div>
      <div v-if="topLevelKeywords.length === 1 && supportingKeywords.length > 0" class="mt-5 flex align-center gap10" style="padding: 7px; border-radius: 4px; background-color: var(--v-gray7Color-base); border: 0.5px solid var(--v-gray15Color-base);">
        <span style="font-weight: 700; color:#fff; background-color: #3180E9; padding: 3px 6px; border-radius: 4px;">SILO</span>
        <span style="font-weight: 700; color: var(--v-mainColor-base);">{{ topLevelKeywords[0].keyword }}</span>
      </div>
      <footer class="footer-container">
        <div
          class="footer-item"
          style="gap: 10px;"
        >
          <v-tooltip top color="black" v-if="topLevelKeywords?.length">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="flex align-center gap5"
                style="border: 1px solid var(--v-gray12Color-base); border-radius: 4px; padding:2px 8px; height: 30px;"
                v-bind="attrs" v-on="on"
              >
                <span style="font-weight: 800; font-size:1.2rem; color: #00A25D;">T</span>
                <span style="font-weight: normal;">{{topLevelKeywords?.length}} top level</span>
              </div>
            </template>
            <div style="max-width: 300px;">
              {{ topLevelKeywords.map(k => k.keyword).join(', ') }}
            </div>
          </v-tooltip>

          <v-tooltip top color="black" v-if="supportingKeywords?.length">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="flex align-center gap5"
                style="border: 1px solid var(--v-gray12Color-base); border-radius: 4px; padding:2px 8px; height: 30px;"
                v-bind="attrs" v-on="on"
              >
                <span style="font-weight: 800; font-size:1.2rem; color: #FF1FA2;">S</span>
                <span style="font-weight: normal;">{{supportingKeywords?.length}} supporting</span>
              </div>
            </template>
            <div style="max-width: 300px;">
              {{ supportingKeywords.map(k => k.keyword).join(', ') }}
            </div>
          </v-tooltip>
        </div>

        <div class="footer-item">
          <b-dropdown
            v-if="isWhiteGloveUser && isMissionControlSession && silo.content_report_order"
            aria-role="list" @click.native.stop
            class="sales-tag-dropdown"
          >
            <template #trigger>
              <v-btn
                style="min-width: 110px;"
                class="sales-tag-btn"
                small
                :color="silo.content_report_order.sales_tag === 'active' ? 'success' : undefined"
              >
                <template v-if="silo.content_report_order.sales_tag === 'passive'">Passive sale</template>
                <template v-else-if="silo.content_report_order.sales_tag === 'active'">Active sale</template>
                <template v-else-if="!silo.content_report_order.sales_tag">-</template>
                <template v-else>{{ silo.content_report_order.sales_tag }}</template>
              </v-btn>
            </template>
            <b-dropdown-item :disabled="silo.content_report_order.sales_tag === 'passive'" aria-role="listitem" @click.native.stop="updateOrder({sales_tag: 'passive'})">Set as passive sale</b-dropdown-item>
            <b-dropdown-item :disabled="silo.content_report_order.sales_tag === 'active'" aria-role="listitem" @click.native.stop="updateOrder({sales_tag: 'active'})">Set as <b>active sale</b></b-dropdown-item>
          </b-dropdown>
        </div>

      </footer>
    </div>
    

    <div class="modal" :class="{ 'is-active': !!showDeleteConfirmModal }">
      <div class="modal-background" @click.stop="showDeleteConfirmModal = false"></div>
      <div class="modal-content">
        <div class="box modal-container" style="overflow: hidden">
          <div class="modal-content-root">
            <div class="title-font is-size-4 mainColor--text">
              You’re about to delete this order
            </div>
            <div class="control flex mt20">
              <div class="flex-grow-1"></div>
              <v-btn
                rounded
                outlined
                color="mainColor"
                class="button-with-icon mainColor--text text-none"
                @click.stop="showDeleteConfirmModal = false"
              >
                <span>Cancel</span>
              </v-btn>
              <v-btn
                rounded
                color="profileAnchorColor"
                class="button-with-icon text-none whiteColor--text"
                @click.stop="deleteSilo"
              >
                <i class="fa fa-trash mr5"></i>
                <span>Delete</span>
              </v-btn>
            </div>
          </div>
        </div>
        <button
          class="custom-modal-close-btn"
          aria-label="close"
          @click.stop="showDeleteConfirmModal = false"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import { getPureServicePkgName } from '@/utils';
import { whiteGlovePlans } from "@/components/plans_constants"
import { getFulfillementStatusLabel } from '@/components/Campaigns/content-orders/utils.js'
import { mixin } from '@/components/mixin'

export default {
  mixins: [mixin, ],
  props: ['silo', 'isProjectLevelView', 'refreshData', 'isSelected'],
  data() {
    return {
      isCardInEditMode: false,
      editedName: '',
      showDeleteConfirmModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    countValue () {
      return (
        (this?.silo?.content_report_order?.selected_top_level_keyword_ids?.length || 0)
        + (this?.silo?.content_report_order?.selected_supporting_keyword_ids?.length || 0)
      )
    },
    topLevelKeywords() {
      return this.silo.silo_keywords.filter(silo_keyword => [
        ...this.silo?.content_report_order?.selected_top_level_keyword_ids || [],
      ].includes(silo_keyword.id))
    },
    supportingKeywords() {
      return this.silo.silo_keywords.filter(silo_keyword => [
        ...this.silo?.content_report_order?.selected_supporting_keyword_ids || [],
      ].includes(silo_keyword.id))
    },
  },
  methods: {
    getFulfillementStatusLabel: getFulfillementStatusLabel,
    showElaspedTime(time) {
      return moment.utc(time).fromNow();
    },
    showDate(time) {
      return moment.utc(time).format("MMM DD");
    },
    onSiloClick(mouseButton='left') {
      const path = `/sites/${this.silo.siteId}/quick-content-orders?id=${this.silo.id}`
      if (mouseButton === 'middle') {
        window.open(this.$router.resolve(path).href, '_blank');
        return false
      } else {
        this.$router.push(path);
      }
    },
    saveEditName() {
      if (this.editedName === this.silo.name) {
        // wait a little in case save is too fast
        // (this fix is needed to prevent navigating to silo when save is triggered by clicking on the silo card)
        return new Promise(r => setTimeout(r, 300))  
          .then(() => {
            this.isCardInEditMode = false;
          }) 
      }
  
      this.updateSilo(
        { name: this.editedName }, true
      )
        .then(() => {
          this.$notify({
            group: 'info',
            type: 'success',
            text: 'Successfully updated order.',
          });
  
          // wait a little in case save is too fast
          // (this fix is needed to prevent navigating to silo when save is triggered by clicking on the silo card)
          return new Promise(r => setTimeout(r, 300))  
            .then(() => {this.isCardInEditMode = false;// this.editableSiteId = null;
          })
        })
    },
    updateSilo(payload, refresh = false) {
      this.$store.commit('showLoading');
      return this.$store
        .dispatch('updateSilo', {
          siloId: this.silo.id,
          body: payload,
        })
        .then(() => {
          if (refresh) {
            this.refreshData();
          }
          return Promise.resolve()
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
    deleteSilo() {
      this.$store.commit('showLoading');
      this.$store
        .dispatch('deleteSilo', this.silo.id)
        .then(() => {
          this.$notify({
            group: 'info',
            type: 'success',
            text: 'Successfully deleted order.',
          });
          this.showDeleteConfirmModal = false;
          this.refreshData();
        });
    },
    updateOrder(payload) {
      this.$store.commit('showLoading');
      this.$store.dispatch('updateSiloContentReportOrder', {
        orderId: this.silo.content_report_order.id,
        body: payload
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.refreshData()
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
  },
};

</script>

<style lang="scss" scoped>
@import './orders.scss';

.page-type-drodown {
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.page-type-btn {
  text-transform: initial;
  letter-spacing: initial;
}

.page-type-assign-btn {
  border: 1px dashed #ccc;
}

.sales-tag-dropdown {
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.sales-tag-btn {
  text-transform: initial;
  letter-spacing: initial;
}

</style>
